import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

import "~/styles/vendor/pannellum.css";
import "pannellum";

export default class extends Controller {
  connect() {
    pannellum.viewer('panorama', {
      "type": "equirectangular",
      "panorama": $('#panorama').data('url'),
      "autoLoad": true,
      "autoRotate": -2,
      "compass": true,
      //"hotSpotDebug": true,
      "hotSpots": [{
        "pitch": 4,
        "yaw": -58,
        "type": "info",
        "text": "Feri jobb szeme"
      }, {
        "pitch": 6.9,
        "yaw": 38.4,
        "type": "info",
        "text": "Valami torony"
      }, {
        "pitch": -0.9,
        "yaw": -123.4,
        "type": "info",
        "text": "Lappföld"
      }]
    });
  }
}
